import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/69c73f6dc3f84800134d10b3/ivydirectory/src/app/sign-up-login-screen/components/AuthPageClient.tsx");
